import isNil from 'lodash/isNil';
import { Author } from '../../../../../models/Product';
import { LoanFormat, mapLoanFormat } from '../../../../../models/LoanFormat';
import { TFunction } from 'i18next';
import { ProductOut } from '../../../../store/api';

export function isProductInList(product: ProductOut, list: ProductOut[]) {
    return list.some(curr => curr.id === product.id);
}

export function createNameList(performers: Author[]) {
    return performers.reduce((acc, curr, index) => {
        if (!curr.name) return acc;
        acc += curr.name;
        if (index < performers.length - 1) {
            acc += ', ';
        }
        return acc;
    }, '');
}

export function getFullName(firstName?: string, lastName?: string) {
    let fullName = '';

    if (!isNil(firstName) && !isNil(lastName)) {
        fullName = `${firstName} ${lastName}`;
    } else if (isNil(lastName)) {
        fullName = `${firstName}`;
    } else if (isNil(firstName)) {
        fullName = `${lastName}`;
    }
    return fullName;
}

export function isValideEpochMsTimestamp(input: unknown) {
    return Number.isInteger(input);
}

export function formatEpochMsToDisplayDate(epochMs: number, t: TFunction) {
    const isValidTimestamp = isValideEpochMsTimestamp(epochMs);
    if (!isValidTimestamp) {
        console.error(`Param "${epochMs}" has to be a number (Epoch MS)`);
        return '';
    }
    return t('dateFormat.dateWithShortMonth', {
        val: new Date(epochMs)
    });
}

export function reorderProductsInList(
    productList: ProductOut[],
    productsToMove: ProductOut[],
    startPosition: number
): ProductOut[] {
    const productsToMoveSorted = productsToMove.sort((a, b) => productList.indexOf(a) - productList.indexOf(b));
    const startPositionDelta = productsToMove.filter(p => productList.indexOf(p) < startPosition).length;

    const newList = productList.filter(p => !isProductInList(p, productsToMove));
    newList.splice(startPosition - startPositionDelta, 0, ...productsToMoveSorted);

    return newList;
}

function getLoanFormatAmount(loanFormat: LoanFormat, productList: ProductOut[]) {
    return productList.reduce((acc, curr) => (mapLoanFormat(curr.loanFormat) === loanFormat ? acc + 1 : acc), 0);
}

export const getLoanFormatEbooksAmount = getLoanFormatAmount.bind(null, LoanFormat.eBooks);
export const getLoanFormatEAudiobooksAmount = getLoanFormatAmount.bind(null, LoanFormat.eAudiobooks);
export const getLoanFormatEMagazineAmount = getLoanFormatAmount.bind(null, LoanFormat.ePress);
